import View from '../View';
import {Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  showEmpty: true,
  displayName: 'Search Result Item',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Search'), iconName('SearchResults')),
  },
  constraints: {
    pinToParent: true,
    ancestors: [
      {
        is: ['SearchResultWrapper'],
        name: 'Form',
        rule: 'ExactlyOne',
      },
    ],
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
